import React, { useState } from 'react'
import clsx from 'clsx'
import { Drawer, Button, List, Divider, ListItem, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom/cjs/react-router-dom'

const useStyles = makeStyles({
    list: {
        width: 250,
        background: 'linear-gradient(150deg, #1551b5, #a5171d)',
        color: '#ffffff',
        height: '100%',
        zIndex: 2,
    },
    link: {
        textDecoration: 'none',
        color: 'inherit',
    },
})

const CustomDrawer = ({
    anchor = 'left',
    buttonLabel = 'Open Drawer',
    items = [],
    zIndex = 99,
    footerItems = [],
    iconMapper = (text, index) => null,
    buttonProps = {},
    drawerWidth = 250,
}) => {
    const classes = useStyles()
    const [open, setOpen] = useState(false)

    const toggleDrawer = (openStatus) => (event) => {
        if (event?.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return
        setOpen(openStatus)
    }

    const renderList = (data) => (
        <List style={{ height: 'calc(100vh - 30px)' }} className="mt-5 pt-3">
            {data.map(({ label, path }, index) => (
                <Link key={label} to={path} className={classes.link} onClick={() => setOpen(false)}>
                    <ListItem button style={{ borderBottom: '0.5px solid #fff' }}>
                        {/* <ListItemIcon>{iconMapper(label, index)}</ListItemIcon> */}
                        <ListItemText primary={label} />
                    </ListItem>
                </Link>
            ))}
        </List>
    )

    return (
        <>
            <Button onClick={toggleDrawer(!open)} {...buttonProps}>
                {buttonLabel}
            </Button>
            <Drawer
                anchor={anchor}
                open={open}
                onClose={toggleDrawer(false)}
                classes={{
                    paper: clsx({ [classes.list]: anchor === 'left' || anchor === 'right' }),
                }}
                PaperProps={{ style: { width: drawerWidth, zIndex: zIndex } }}
            >
                <div
                    className={clsx(classes.list, {
                        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
                    })}
                    role="presentation"
                    onKeyDown={toggleDrawer(false)}
                >
                    {renderList(items)}
                    {footerItems.length > 0 && <Divider />}
                    {footerItems.length > 0 && renderList(footerItems)}
                </div>
            </Drawer>
        </>
    )
}

export default CustomDrawer
